import { useMutation } from 'react-query';
import { deleteEntityDraftLogo } from '../apis/DeleteDraftLogo';

export const useDeleteEntityDraftLogoMutation = () =>
  useMutation(deleteEntityDraftLogo);
